import React from 'react';
import { Form, Input, Button,Spin,Select,DatePicker, Divider,Tabs } from 'antd';
import axios from 'axios'
import * as serverconfig from '../serverconn'
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined,UploadOutlined } from '@ant-design/icons';
import moment from 'moment';

var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var token= ''
var username=''
const dateFormat = 'DD/MM/YYYY';
const { TextArea } = Input;
const { TabPane } = Tabs;



const { Option } = Select;

class CommunicationTemplateForm extends React.Component {

  state = {
    datarequested:true,
    body:'',
    subject:'',
    communication_type:'',

  }

  componentDidMount(){   
    this.component_reloaded()
  }


  component_reloaded=()=>{
    this.setState({datarequested:true})

    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    if(localStorage.getItem("username")){
      username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
   }else{
      username=''
   }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    this.setState({datarequested:false})

  }


  //submit button pressed
  handleFormSubmit=(event) =>{
    this.setState({datarequested:true})
    let form_data = new FormData();

    form_data.append('body', this.state.body);
    form_data.append('subject', this.state.subject);
    form_data.append('communication_type', this.state.communication_type);
    form_data.append('action', this.props.actionobj.id);

    axios.post(serverconfig.backendserverurl+'/api/communication_templates/', form_data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  .then(res => {
    this.setState({datarequested:false})
    //this.component_reloaded()

    ///refesrh
    this.props.onRefresh()

  }    

  )
  .catch(error => console.log(error))

  }

  
  render(){

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return (
        <div>
    <Form
        onFinish={(event) => this.handleFormSubmit(event)}
    >
       <FormItem label="subject"
        name="subject"
        rules={[
          {
            required: false,
            message: 'Please input subject',
          },
        ]}
      >
        <Input name="subject"  
         placeholder="subject"
         value={this.state.subject} 
         onChange={(val)=>{this.setState({subject:val.target.value})}} />
      </FormItem> 

      <FormItem label="Body">
        <TextArea
            placeholder="Body"
            autoSize={{ minRows: 2, maxRows: 6 }}
            value={this.state.body}
            onChange={(val)=>{this.setState({body:val.target.value})}}
          />
      </FormItem>



      <FormItem label="Group"
        name="commodity_group"
        rules={[
          {
            required: true,
            message: 'Please select',
          },
        ]}
      >
          <Select 
          placeholder="Group" 
          style={{  }} 
          value={this.state.commodity_group}
          onChange={(val)=>{
            this.setState({commodity_group:val})
          }} 
          showSearch
          optionFilterProp="children"
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onSearch={this.onSearch}   
          >
            <Option value={'Email'}>{'Email'}</Option>
            <Option value={'SMS'}>{'SMS'}</Option>
            <Option value={'In-App Notification'}>{'In-App Notification'}</Option>
          </Select>
      </FormItem>

      <FormItem>
        <Button  type="primary" htmlType="submit">Add Template </Button>
      </FormItem>


       </Form>
        </div>
      );
    }

  }

}


export default CommunicationTemplateForm;



